export type AppLocale = 'ja' | 'en' | 'zh';

export function detectLocale(): AppLocale {
  const lang = (navigator.language || 'en').toLowerCase();
  if (lang.startsWith('ja')) return 'ja';
  if (lang.startsWith('zh')) return 'zh';
  return 'en';
}

export function localeToBcp47(locale: AppLocale): string {
  switch (locale) {
    case 'ja':
      return 'ja-JP';
    case 'zh':
      return 'zh-CN';
    default:
      return 'en-US';
  }
}

export function localeToHtmlLang(locale: AppLocale): string {
  switch (locale) {
    case 'ja':
      return 'ja';
    case 'zh':
      return 'zh-Hans';
    default:
      return 'en';
  }
}

/** グループ枠・フッター統計ラベル（全言語英語固定） */
export const ENGLISH_UI_LABELS = {
  SUBTOTAL: 'SUBTOTAL',
  TOTAL: 'TOTAL',
  COUNT: 'COUNT',
  AVERAGE: 'AVERAGE',
  MAX: 'MAX',
  MIN: 'MIN',
  GRID: 'Grid',
  GUIDE: 'Guide',
} as const;
